export default __webpack_public_path__ + "static/media/Path 4@2x.be4cbac7.png";